<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <!-- <b-modal ref="notificationsModal" scrollable hide-footer hide-header no-close-on-backdrop size="lg" body-class="custom_alert_body less-top-padding less-bottom-padding">
            <NotificationBox></NotificationBox>
            <div class="row">
                <center class="container">
                    <hr>
                    <base-button type="primary" @click="closeModal()" class="btn-primary">Okay thanks!</base-button>
                </center>
            </div>
        </b-modal> -->
      <div class="col-md-2 align-left">
        <router-link
          v-if="isLogistics && !isPartnerAccount"
          :to="'/order/edit/0'"
          style="font-size: 11.5px;padding-top: 3px; padding-bottom: 3px;"
          class="btn btn-secondary  more-margin-top"
          ><span
            ><i style="font-size: 11.5px;" class="tim-icons icon-simple-add"></i> Create New Order</span
          ></router-link
        >
        <router-link v-if="isLogistics && !isPartnerAccount"
          :to="'/import/order'"
           style="font-size: 11.5px; padding-top: 3px; padding-bottom: 3px;"
          class="btn btn-secondary  more-margin-top"
          ><span
            ><i style="font-size: 11.5px;" class="tim-icons icon-cloud-upload-94"></i> Import ACSA
            Orders</span
          ></router-link
        >
      </div>
      <div class="col-md-12" v-if="!isOUSD && !isPartnerAccount && !isPNManager">
        <tabs
          type="primary"
          tabContentClasses="tab-subcategories"
          square
          centered
        >
          <tab-pane
            v-for="item in subPages"
            :key="item.id"
            :defaultTabIndex="1"
          >
            <span slot="label">
              <i :class="['tim-icons', item.icon]"></i>
              {{ item.text }}
            </span>
            <div>
              <DraftTab v-if="item.text === 'Draft'"></DraftTab>
            </div>
            <ActiveTab v-if="item.text === 'Active'"></ActiveTab>
            <CompleteTab v-if="item.text === 'Complete'"></CompleteTab>
            <PartnerNationTab
              v-if="item.text === 'Country'"
            ></PartnerNationTab>
            <OrganizationTab
                v-if="item.text === 'Organization'"
              ></OrganizationTab>
          </tab-pane>
        </tabs>
      </div>
      
      <div class="col-md-12" v-else>
        <div class="col-md-12" v-if="isOUSD">
          <tabs
            type="primary"
            tabContentClasses="tab-subcategories"
            square
            centered
          >
            <tab-pane
              v-for="item in subPagesForOUSDAccount"
              :key="item.id"
              :defaultTabIndex="0"
            >
              <span slot="label">
                <i :class="['tim-icons', item.icon]"></i>
                {{ item.text }}
              </span>
              <ActiveTab v-if="item.text === 'Active'"></ActiveTab>
              <OrganizationTab
                v-if="item.text === 'Organization'"
              ></OrganizationTab>
            </tab-pane>
          </tabs>
        </div>

        <div class="col-md-12" v-if="isPartnerAccount">
          <tabs
            type="primary"
            tabContentClasses="tab-subcategories"
            square
            centered
          >
            <tab-pane
              v-for="item in subPagesForPartnerAccount"
              :key="item.id"
              :defaultTabIndex="0"
            >
              <span slot="label">
                <i :class="['tim-icons', item.icon]"></i>
                {{ item.text }}
              </span>
              <ActiveTab v-if="item.text === 'Active'"></ActiveTab>
              <!-- THis was === 'Country', is this by design or a typo -->
            <CompleteTab v-if="item.text === 'Complete'"></CompleteTab>
              
            <OrganizationTab
              v-if="item.text === 'Country'"
            ></OrganizationTab>
              <PartnerNationUnsignedTab
                v-if="item.text === 'Unsigned'"
              ></PartnerNationUnsignedTab>
            </tab-pane>
          </tabs>
        </div>

        <div class="col-md-12" v-if="isPNManager">
          <tabs
          type="primary"
          tabContentClasses="tab-subcategories"
          square
          centered
        >
          <tab-pane
            v-for="item in subPagesForPartnerNationManager"
            :key="item.id"
            :defaultTabIndex="1"
          >
            <span slot="label">
              <i :class="['tim-icons', item.icon]"></i>
              {{ item.text }}
            </span>
            <div>
              <DraftTab v-if="item.text === 'Draft'"></DraftTab>
            </div>
            <ActiveTab v-if="item.text === 'Active'"></ActiveTab>
            <CompleteTab v-if="item.text === 'Complete'"></CompleteTab>
            <OrganizationTab
              v-if="item.text === 'Organization'"
            ></OrganizationTab>
            <PartnerNationTab
              v-if="item.text === 'Partner Nation'"
            ></PartnerNationTab>
          </tab-pane>
        </tabs>
        </div>
      </div>
    </div>
  </center>
</template>

<script>
import DraftTab from "@/components/App/dashboard/DraftTab.vue";
import ActiveTab from "@/components/App/dashboard/ActiveTab.vue";
import CompleteTab from "@/components/App/dashboard/CompleteTab.vue";
import PartnerNationTab from "../components/App/dashboard/PartnerNationTab.vue";
import PartnerNationUnsignedTab from "../components/App/dashboard/PartnerNationUnsignedTab.vue";
import OrganizationTab from "@/components/App/dashboard/OrganizationTab.vue";
import NotificationBox from "@/components/App/dashboard/NotificationBox.vue";
import Header from "@/components/App/Header.vue";
import Util from "@/util/util";
import { mapGetters, mapActions } from "vuex";
import { Tabs, TabPane } from "@/components";
import {  Button } from "element-ui";


export default {
  data() {
    return {
      subPages: [
        {
          id: 1,
          text: "Draft",
          icon: "icon-pencil",
        },
        {
          id: 2,
          text: "Active",
          icon: "icon-user-run",
        },
        {
          id: 3,
          text: "Complete",
          icon: "icon-check-2",
        },
        {
          id: 4,
          text: "Organization",
          icon: "icon-bank",
        },
       
      ],
      subPagesForPartnerAccount: [
        {
          id: 1,
          text: "Active",
          icon: "icon-user-run",
        },

        {
          id: 2,
          text: "Complete",
          icon: "icon-check-2",
        },
        {
          id: 3,
          text: "Country",
          icon: "icon-bank",
        },
        {
          id: 4,
          text: "Unsigned",
          icon: "icon-pencil"
        }
      ],
      subPagesForPartnerNationManager:[
        {
          id: 1,
          text: "Draft",
          icon: "icon-pencil",
        },
        {
          id: 2,
          text: "Active",
          icon: "icon-user-run",
        },
        {
          id: 3,
          text: "Complete",
          icon: "icon-check-2",
        },
        {
          id: 4,
          text: "Organization",
          icon: "icon-bank",
        },
      {
          id: 5,
          text: "Partner Nation",
          icon: 'icon-compass-05',
        },
      ]
      ,
      subPagesForOUSDAccount: [
        {
          id: 1,
          text: "Organization",
          icon: "icon-bank",
        },
      ],
      wizardModel: {},
    };
  },
  components: {
    Tabs,
    TabPane,
    DraftTab,
    ActiveTab,
    CompleteTab,
    OrganizationTab,
    PartnerNationTab,
    Header,
    NotificationBox,
    PartnerNationUnsignedTab,
      [Button.name]: Button,
  },
  computed: {
    ...mapGetters({
      isLogistics: "authentication/isLogistics",
      isPartnerAccount: "authentication/isPartnerAccount",
      notificationsAlreadyShown: "notifications/notificationsAlreadyShown",
      isOUSD: "authentication/isOUSD",
      isPNManager: "authentication/isPNManager",
    }),
  },
  async mounted() {
    this.$loaderApp.addRequest();
    if (!this.notificationsAlreadyShown) {
      if (!Util.isNull(this.$refs.notificationsModal)) {
        this.$refs.notificationsModal.show();
      }
      this.setNotificationsAlreadyShown(true);
    }
    this.$store
      .dispatch("clearAllOrderData")
      .then(() => {
        //TODO: MIGHT BE A GOOD PLACE TO LOAD ORDER DATA FROM THE SERVER IF IN VIEW OR EDIT MODE INSTEAD OF CREATE FOR THE ORDER
      })
      .catch((error) => {
        console.log(error.stack); //not handelled
      });
    await this.$store.dispatch("users/getUserByEmail");
    this.$loaderApp.completeRequest();

  },
  methods: {
    ...mapActions({
      setNotificationsAlreadyShown:
        "notifications/setNotificationsAlreadyShown",
    }),
    openModal() {
      if (!Util.isNull(this.$refs.notificationsModal)) {
        this.$refs.notificationsModal.show();
      }
    },
    closeModal() {
      if (!Util.isNull(this.$refs.notificationsModal)) {
        this.$refs.notificationsModal.hide();
      }
    },
  },
};
</script>

<style scoped>
.card-container {
  padding-bottom: 0px;
}

/* This is for smaller tabs on Dashboard and Order page */
@media only screen and (max-width: 768px) {
  .nav-pills .nav-item .nav-link {
    padding: 0px;
    min-width: 85px;
  }
}

/* This is for smaller tabs on Dashboard and Order page */
@media only screen and (max-width: 545px) {
  .nav-pills .nav-item .nav-link {
    padding: 0px;
    min-width: 65px;
  }
}
</style>
